var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.1547C13.4876 0.440169 15.0124 0.440169 16.25 1.1547L24.3744 5.8453C25.612 6.55983 26.3744 7.88034 26.3744 9.3094V18.6906C26.3744 20.1197 25.612 21.4402 24.3744 22.1547L16.25 26.8453C15.0124 27.5598 13.4876 27.5598 12.25 26.8453L4.12564 22.1547C2.88804 21.4402 2.12564 20.1197 2.12564 18.6906V9.3094C2.12564 7.88034 2.88804 6.55983 4.12564 5.8453L12.25 1.1547Z",
    fill: "url(#paint0_linear_870_1218)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.1547C13.4876 2.44017 15.0124 2.44017 16.25 3.1547L22.6423 6.8453C23.8799 7.55983 24.6423 8.88034 24.6423 10.3094V17.6906C24.6423 19.1197 23.8799 20.4402 22.6423 21.1547L16.25 24.8453C15.0124 25.5598 13.4876 25.5598 12.25 24.8453L5.8577 21.1547C4.62009 20.4402 3.8577 19.1197 3.8577 17.6906V10.3094C3.8577 8.88034 4.62009 7.55983 5.8577 6.8453L12.25 3.1547Z",
    fill: "url(#paint1_linear_870_1218)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.1547C13.4876 3.44017 15.0124 3.44017 16.25 4.1547L21.7763 7.3453C23.0139 8.05983 23.7763 9.38034 23.7763 10.8094V17.1906C23.7763 18.6197 23.0139 19.9402 21.7763 20.6547L16.25 23.8453C15.0124 24.5598 13.4876 24.5598 12.25 23.8453L6.72372 20.6547C5.48612 19.9402 4.72372 18.6197 4.72372 17.1906V10.8094C4.72372 9.38034 5.48612 8.05983 6.72372 7.3453L12.25 4.1547Z",
    fill: "url(#paint2_linear_870_1218)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.1547C13.4876 5.44017 15.0124 5.44017 16.25 6.1547L20.0442 8.3453C21.2818 9.05983 22.0442 10.3803 22.0442 11.8094V16.1906C22.0442 17.6197 21.2818 18.9402 20.0442 19.6547L16.25 21.8453C15.0124 22.5598 13.4876 22.5598 12.25 21.8453L8.45577 19.6547C7.21817 18.9402 6.45577 17.6197 6.45577 16.1906V11.8094C6.45577 10.3803 7.21817 9.05983 8.45577 8.3453L12.25 6.1547Z",
    fill: "url(#paint3_linear_870_1218)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 19V12.6562H10.9453V11.3574C11.6016 11.3164 12.096 11.2389 12.4287 11.125C12.766 11.0065 13.0326 10.8242 13.2285 10.5781C13.429 10.332 13.5863 9.98568 13.7002 9.53906H15.1699V19H13.2422Z",
    fill: "#FD960C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_1218",
    x1: 0.25,
    y1: 0,
    x2: 28.25,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE79F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_870_1218",
    x1: 2.25,
    y1: -7.94729e-8,
    x2: 26.25,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_870_1218",
    x1: 6.25,
    y1: 1.5,
    x2: 22.75,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA90E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD960C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_870_1218",
    x1: 5.25,
    y1: 5,
    x2: 21.9,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE183"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.df19e7bcf5175679870ca8ef46ccd5a9.svg";
export { ForwardRef as ReactComponent };